import './social_content.js.coffee'
Namespace 'Monitoring.Models.SocialContents'

class Monitoring.Models.SocialContents.AnalysisUnit extends Monitoring.Models.SocialContents.SocialContent

  isMention: ->
    false

  groupType: ->
    @_getContent().getGroupType()

  type: ->
    @_getContent().getType()

  subType: ->
    @_getContent().getSubType()

  origin: ->
    if @_getContent().getOrigin
      @_getContent().getOrigin()
    else
      ''

  privacy: ->
    @_getContent().getPrivacy()

  externalId: ->
    @_getContent().getContentId()

  link: ->
    @_getContent().getLink()

  title: ->
    @_getContent().getTitle()

  isBrandContent: ->
    @_getContent().isBrandContent()

  hasUser: ->
    @_getContent().hasUser()

  hasProfile: ->
    @_getContent().hasProfile()

  hasRelated: ->
    @_getContent().hasRelated()

  hasContext: ->
    @_getContent().hasContext?()

  name: ->
    @_getContent().getAuthorName()

  username: ->
    @_getContent().getAuthorUsername()

  avatar: ->
    @_getContent().getAvatar()

  contentUrl:->
    @_getContent().getContentUrl?()

  channelText: ->
    @_getContent().getChannelText()

  created_at: ->
    @_getContent().getCreatedAt()

  userId: ->
    @_getContent().getAuthorId()

  content: ->
    @_getContent().getMainText()

  enhancedContent: ->
    return '' unless @_getContent().getMainText()
    super

  hasShares: ->
    @_getContent().hasShares()

  getShares: ->
    @_getContent().getShares()

  hasAttachments: ->
    @_getContent().hasAttachments()

  getAttachments: (type) ->
    if @_getContent().getAttachments then @_getContent().getAttachments(type) else []

  hasQuickReplies: ->
    @_getContent().hasQuickReplies()

  getQuickReplies: ->
    @_getContent().getQuickReplies()

  isListeningOnly: ->
    @_getContent().isListeningOnly && @_getContent().isListeningOnly()

  hasContentUrl: ->
    typeof @_getContent().contentUrl == 'function'

  contentUrl: ->
    if @_getContent().contentUrl() then @_getContent().contentUrl() else null

  starRating: ->
    if @_getContent().starRating() then @_getContent().starRating() else null

  isAnonymousUser: ->
    if @_getContent().isAnonymousUser() then @_getContent().isAnonymousUser() else null

  webchatHistory: ->
    historyJSON = @_getContent().getWebchatHistory?()
    return null unless historyJSON
    new Customer.Webchat.WebchatHistory historyJSON

  _getContent: ->
    @get('content')

  uniqueId: ->
    UniqueId.get(@externalId())

  getRootParentId: ->
    @_getContent().getRootParentId()

  getImmediateParentId: ->
    @_getContent().getImmediateParentId()

  getOrigin: ->
    @_getContent().getOrigin()
